export const validateNotEmpty = (value) => {
    return typeof value === 'string' && value.trim() !== '';
}

export const validateEmail = (value) => {
    // Regular expression for a basic email validation
    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    // Test the email against the regex
    return emailRegex.test(value);
}